import { ca } from '@cian/analytics';
import { TIndexTab } from '../../types/redux';

const mapTabName = {
  0: 'tab/quantity',
  1: 'tab/proportion',
  2: 'tab/average',
};

const mapRegionName: { [key: number]: string } = {
  0: 'tab/Moscow',
  1: 'tab/StPetersburg',
};

export function trackTabClick(indexTab: TIndexTab) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Click',
    label: mapTabName[indexTab],
  });
}

export function trackRegionClick(indexRegion: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Click',
    label: mapRegionName[indexRegion],
  });
}
